import { ThemeType } from '@gravity-ui/uikit';
import { useState } from 'react';
import { getUserTheme } from '../libs/theme-controllers/getUserTheme';
import { saveUserTheme } from '../libs/theme-controllers/saveUserTheme';

const defaultTheme = getUserTheme();

export const useTheme = () => {
    const [theme, setTheme] = useState<ThemeType>(defaultTheme);

    const toggleTheme = () => {
        const nextTheme = theme === 'dark' ? 'light' : 'dark';
        saveUserTheme(nextTheme);
        setTheme(nextTheme);
    };

    return { theme, toggleTheme };
};
